import React from 'react'

import {MainAndModalRoutes} from 'src/nav/Stacks/Routes'
import {ModalStackNav, ModalStackScreenOptions} from 'src/nav/Stacks/consts'

export const ModalStack = () => {
  return <MainAndModalRoutes StackNav={ModalStackNav} baseOptions={ModalStackScreenOptions} />
}
